// 消防演习类型
export const exerciseOptions = [
  { title: "内部演习", key: 1 },
  { title: "统一演习", key: 2 },
];